import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import shortid from 'shortid';
import { startCase } from 'lodash';

import { tagLink } from '../../../utils/blog-utils';

const TagsList = () => (
  <StaticQuery
    query={graphql`
      {
        allMarkdownRemark (
            filter: {fields: {collection: {eq: "blog-posts"}}}
        ){
          distinct(field: frontmatter___tags)
        }
      }
    `}
    render={(data) => {
      const tags = data.allMarkdownRemark.distinct;

      return (
        <div className="blogSidebar__section">
          <h2>Tags</h2>

          <ul className="tags">
            {tags.map(tag =>
              <li key={shortid.generate()}>
                <a
                  href={tagLink(tag)}
                  className="article__tag"
                >
                  {startCase(tag)}
                </a>
              </li>
            )}
          </ul>
        </div>
      );
    }}
  />
);

export default TagsList;
